<template>
  <div class="toothbrushes">
    <div class="row">
      <Toothbrush v-for="t in toothbrushes"
                  v-on:click.native="showToothpaste(t)"
                  v-bind:key="t.key"
                  :title="t.title"
                  :imgUrl="t.imgUrl"
                  :colorClass="'bg--'+t.key"
      ></Toothbrush>
    </div>
    <transition name="fade" mode="out-in">
      <div class="container" v-bind:key="toothbrush.name" v-if="redirect && selected">
        <div class="row">
          <div class="col-md-12">
            <ToothbrushInfo :toothbrush="toothbrush" v-bind:key="toothbrush.name" :redirect="redirect"></ToothbrushInfo>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Toothbrush from './Toothbrush.vue'
import ToothbrushInfo from './ToothbrushInfo.vue'
import Toothbrushes from '../toothbrushes'
import VueScrollTo from 'vue-scrollto'

export default {
  props: {
    selected: false,
    redirect: true
  },
  data () {
    return {
      toothbrushes: Toothbrushes
    }
  },
  components: {
    Toothbrush,
    ToothbrushInfo
  },
  computed: {
    toothbrush: function () {
      const _this = this
      let toothbrush = this.toothbrushes.find(function (obj) {
        return obj.name.split(' ').join('-') === _this.selected
      })
      toothbrush = Object.assign({}, toothbrush)
      if (!toothbrush) {
        return false
      }
      toothbrush.gender = 'both'

      return toothbrush
    }
  },

  methods: {
    showToothpaste: function (toothbrush) {
      this.$emit('color-choose', Object.assign({}, toothbrush))
      if (this.redirect) {
        this.$router.push({name: 'Paste', params: { paste: toothbrush.name.split(' ').join('-') }})
      }
      VueScrollTo.scrollTo('.quiz')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .toothbrushes {
    .row {
      margin: 0;
    }
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Toothbrushes.vue